import { cn } from '../../../lib/utils'
import { AwardsSvgIcon, CaloriesSvgIcon, DumbbellSvgIcon, HustleSvgIcon } from '../../util/images'
import React from 'react'

export type WorkoutStatIconType = 'dumbbell' | 'calories' | 'hustle' | 'awards'

interface WorkoutStatIconProps {
  iconType: WorkoutStatIconType
}

const iconTypeToComponent = {
  dumbbell: DumbbellSvgIcon,
  calories: CaloriesSvgIcon,
  hustle: HustleSvgIcon,
  awards: AwardsSvgIcon,
}

export const WorkoutStatIcon = ({ iconType }: WorkoutStatIconProps): React.ReactElement => {
  const IconComponent = iconTypeToComponent[iconType]

  return (
    <div className={cn('absolute left-5 top-5 z-10')}>
      <IconComponent />
    </div>
  )
}
